import { TextPayload } from '../TextPayload/TextPayload';

export class DeletedByMePayload extends TextPayload {
  text = '';
  userMentions = null;
  keyWord = null;
  keyWords = [];
  linkPreview = undefined;
  linkPreviewCancelled = false;
}
